import React, { useEffect, useState } from 'react';
import BarcodeService from 'services/eva/BarcodeService';
import { useIntl } from 'react-intl';

type Props = {
  value: string;
};

export default function Barcode(props: Props): JSX.Element {
  const intl = useIntl();
  const [barcodeUrl, setBarcodeUrl] = useState<string>();

  useEffect(() => {
    BarcodeService.getBarcodeUrl(props.value).then(url => setBarcodeUrl(url));
  }, [props.value]);

  return (
    <div>
      {barcodeUrl && (
        <img src={barcodeUrl} alt={intl.formatMessage({ id: 'my-rituals' })} />
      )}
    </div>
  );
}
